import { Component } from '@angular/core';

@Component({
  selector: 'app-tank-icon',
  templateUrl: './tank-icon.component.svg',
  styleUrls: ['./tank-icon.component.scss']
})
export class TankIconComponent
{

  constructor() { }

}
